export const options = {
  attributionWidthOffset: 55,
};

export default options;
